import {Grid, Typography} from '@logistics-frontend/blocks'

import {i18n} from 'src/shared/config'

import {removeLeadingPostalCode} from '../../utils/remove-leading-postal-code'
import {useDetails} from '../hooks'
import {classes} from './DropOffPointDetails.classes'
import type {Props} from './types'

export function DropOffPointDetails(props: Props) {
  const {point} = props
  const {schedule} = useDetails(point)

  return (
    <Grid className={classes.table} size="s" container>
      <Grid justify="space-between" wrap="nowrap" container item>
        <Grid item xs>
          <Typography group="tight" variant="body2">
            {i18n('ndd.pickup_points.schedule', 'График работы')}
          </Typography>
        </Grid>
        <Grid alignItems="flex-end" direction="column" container item xs>
          {schedule.map((scheduleDate, idx) => (
            <Typography key={idx} Component={Grid} group="tight" variant="body2" whiteSpace="nowrap">
              {scheduleDate}
            </Typography>
          ))}
        </Grid>
      </Grid>
      <Grid justify="space-between" wrap="nowrap" container item>
        <Grid item>
          <Typography group="tight" variant="body2">
            {i18n('ndd.dropoff_points.return_station', 'Возвраты')}
          </Typography>
        </Grid>
        <Grid className={classes.longTextCell} item>
          <Typography group="tight" variant="body2">
            {point.return_station?.address
              ? i18n('ndd.dropoff_points.return_station.station_address', {
                  placeholder: {
                    stationAddress: removeLeadingPostalCode(point.return_station.address.full_address),
                  },
                })
              : i18n('ndd.dropoff_points.return_station.same_station', 'можно забрать из этого пункта')}
          </Typography>
        </Grid>
      </Grid>
      {point?.type === 'warehouse' && (
        <Grid justify="space-between" wrap="nowrap" container item>
          <Grid item xs>
            {i18n('ndd.dropoff_points.warehouse.gabarits.label', 'Максимальные габариты посылки')}
          </Grid>
          <Grid alignItems="flex-end" direction="column" container item xs>
            <Typography Component={Grid} variant="caption1" item>
              {i18n('ndd.dropoff_points.warehouse.gabarits.size', '300 x 250 x 250 см')}
            </Typography>
            <Typography Component={Grid} variant="caption1" item>
              {i18n('ndd.dropoff_points.warehouse.gabarits.sum_measure', 'сумма сторон 500 см')}
            </Typography>
            <Typography Component={Grid} variant="caption1" item>
              {i18n('ndd.dropoff_points.warehouse.gabarits.weight', '200 кг')}
            </Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}
